module.exports = __webpack_public_path__ + "static/media/homedepot.939524d1.jpg";